<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
        <vue-headful :title="(entry.employee_id ? entry.FirstName+' '+entry.LastName : entry.person_name) + ' - '+entry.covid_form_name+' [Custom Form] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/custom-forms`">
                            <i class="fa fa-file-text"></i> Custom Forms
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ entry.covid_form_name }} -
                        <template v-if="entry.employee_id">
                            {{ entry.FirstName }} {{ entry.LastName }}
                        </template>
                        <template v-else>
                            {{ entry.person_name }}
                        </template>
                        - {{ entry.created_at | moment("MM/DD/YYYY") }}
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-xl-7 d-xl-block d-none">
                    <covid-sections-view :sections="sections" labelSize="col-md-4 col-12 text-md-right text-muted" fieldSize="col-md-8 col-12"></covid-sections-view>
                </div>

                <div class="col-xl-5 col-lg-12 mb-xl-0 mb-4">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Entry Details:</strong>

                            <div class="pull-right" v-if="canEdit">
                                <router-link :to="`/custom-forms/entry/status/${entry.id}`" class="btn btn-sm btn-default" v-if="canEdit" title="Edit Form Status">
                                    <i class="fa fa-bolt"></i> Status
                                </router-link>
                                <router-link :to="`/custom-forms/entry/edit/${entry.id}`" class="btn btn-sm btn-default" v-if="canEdit">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>

                                <b-dropdown variant="default" size="sm">
                                    <template slot="button-content">
                                        <i class="fa fa-file-pdf-o"></i> PDF
                                    </template>
                                    <b-dropdown-item href="#">
                                        <router-link :to="`/custom-forms/entry/pdf/${entry.id}`">
                                            PDF from HTML
                                        </router-link>
                                    </b-dropdown-item>
                                    <b-dropdown-item href="#">
                                        <router-link :to="`/custom-forms/entry/pdf/${entry.id}/build`">
                                            PDF Builder
                                        </router-link>
                                    </b-dropdown-item>
                                </b-dropdown>

                                <router-link :to="`/custom-forms/entry/delete/${entry.id}`" class="btn btn-sm btn-default" v-if="this.$root.hasPermission('custom_forms.manage')">
                                    <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-xl-4 col-12 text-md-right text-muted">Form:</div>
                                <div class="col-xl-8 col-12">
                                    <router-link :to="`/custom-forms/forms/view/${entry.covid_form_id}`" v-if="this.$root.hasPermission('custom_forms.manage')">
                                        {{ entry.covid_form_name }}
                                    </router-link>
                                    <template v-else>
                                        {{ entry.covid_form_name }}
                                    </template>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-xl-4 col-12 text-md-right text-muted">Completed By:</div>
                                <div class="col-xl-8 col-12">
                                    <router-link :to="`/employees/view/${entry.employee_id}`" v-if="entry.employee_id">
                                        {{ entry.FirstName }} {{ entry.LastName }} - {{ entry.EmployeeNumber }}
                                    </router-link>
                                    <template v-else>
                                        {{ entry.person_name }}
                                    </template>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-xl-4 col-12 text-md-right text-muted">Date Completed:</div>
                                <div class="col-xl-8 col-12">
                                    {{ entry.created_at | moment('timezone', userTimezone, 'MM/DD/YYYY hh:mm a') }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-xl-4 col-12 text-md-right text-muted">Jobsite:</div>
                                <div class="col-xl-8 col-12">
                                    <router-link :to="`/jobsites/view/${entry.jobsite_id}`" v-if="entry.jobsite_id">{{ entry.JobsiteNumber }} - {{ entry.JobsiteName }}</router-link>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-xl-4 col-12 text-md-right text-muted">Status:</div>
                                <div class="col-xl-8 col-12">
                                    <label :class="'badge badge-'+(entry.entry_status == 'Open' ? 'danger' : 'success')+''">{{ entry.entry_status }}</label>
                                </div>
                            </div>
                            <div class="row mb-2" v-if="entry.last_status_at">
                                <div class="col-xl-4 col-12 text-md-right text-muted">Status Changed:</div>
                                <div class="col-xl-8 col-12">
                                    {{ entry.last_status_at | moment('timezone', userTimezone, 'MM/DD/YYYY hh:mm a') }}
                                </div>
                            </div>
                            <div class="row mb-2" v-if="entry.status_changed_by">
                                <div class="col-xl-4 col-12 text-md-right text-muted">Status Changed By:</div>
                                <div class="col-xl-8 col-12">
                                    {{ entry.status_user_first_name }} {{ entry.status_user_last_name }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3" v-if="personnel.length > 0">
                        <div class="card-header">
                            <strong>Personnel ({{ personnel.length }}):</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-1" v-for="person in personnel">
                                <div class="col-xl-4 col-12 text-md-right text-muted">{{ person.field_label }}:</div>
                                <div class="col-xl-8 col-12">
                                    <router-link :to="`/employees/view/${person.employee_id}`" v-if="person.employee_id">
                                        {{ person.employee_first_name }} {{ person.employee_last_name }} - {{ person.EmployeeNumber }}
                                    </router-link>
                                    <span v-else>
                                        {{ person.other_personnel_name }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header">
                            <strong>Sign and Date:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-1">
                                <div class="col-lg-4 col-12 text-md-right text-muted">Date:</div>
                                <div class="col-lg-8 col-12">
                                    {{ entry.created_at | moment('timezone', userTimezone, 'MM/DD/YYYY hh:mm a') }}
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-lg-4 col-12 text-md-right text-muted">Jobsite:</div>
                                <div class="col-lg-8 col-12">
                                    <router-link :to="`/jobsites/view/${entry.jobsite_id}`" v-if="entry.jobsite_id">{{ entry.JobsiteNumber }} - {{ entry.JobsiteName }}</router-link>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-4 col-12 text-md-right text-muted">
                                    <template v-if="entry.employee_id">
                                        Employee:
                                    </template>
                                    <template v-else>
                                        Guest:
                                    </template>
                                </div>
                                <div class="col-lg-8 col-12">
                                    <router-link :to="`/employees/view/${entry.employee_id}`" v-if="entry.employee_id">
                                        {{ entry.FirstName }} {{ entry.LastName }}
                                    </router-link>
                                    <template v-else>
                                        {{ entry.person_name }}
                                    </template>
                                </div>
                            </div>

                            <img ref="signatureFile" src="" class="img-fluid" v-if="entry.signature_file_id" />
                        </div>
                    </div>
                </div>

                <div class="d-xl-none col-lg-12">
                    <covid-sections-view :sections="sections" labelSize="col-md-4 col-12 text-md-right text-muted" fieldSize="col-md-8 col-12"></covid-sections-view>
                </div>
            </div>

            <div>
                <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none">
                    <b-nav-item :active="curTab === 'history'" @click="curTab = 'history'">
                        <i class="fa fa-clock"></i> History <template v-if="totalHistory != null">({{ totalHistory }})</template>
                    </b-nav-item>
                </ul>

                <div class="mb-2 mb-lg-0 d-lg-none d-block">
                    <b-dropdown :html="getTabTitle" variant="default" class="bg-white">
                        <b-dropdown-item :active="curTab === 'history'" @click="curTab = 'history'">
                            <i class="fa fa-clock"></i> History <template v-if="totalHistory != null">({{ totalHistory }})</template>
                        </b-dropdown-item>
                    </b-dropdown>
                </div>

                <div class="card">
                    <div class="card-body">
                        <div v-show="curTab === 'history'">
                            <history-list
                                recordType="CovidFormEntry"
                                :recordId="entry.id"
                                @historyCount="(total) => { this.totalHistory = total; }" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style type="text/css">
    .signature-pad {
        width: 100%;
        height: 300px;
        border: 1px solid #ddd;
    }
</style>

<script>
    export default {
        data() {
            return {
                loading: true,
                id: this.$route.params.id,
                userTimezone: this.$store.state.user.timezone,
                entry: {},
                personnel: [],
                covid_fields: [],
                totalHistory: null,
                curTab: 'history',
            }
        },

        computed: {
            canEdit(){
                if(this.$root.hasPermission('custom_forms.manage'))
                {
                    return true;
                }

                //Check Employee ID vs. Current User
                if(this.$store.state.user.EmployeeId !== null && this.$store.state.user.EmployeeId === this.entry.employee_id)
                {
                    return true;
                }

                return false;
            },

            sections(){
                //Setup
                var covid_fields = [];

                //Loop through and build lists
                for(var i = 0; i < this.covid_fields.length; i++)
                {
                    //Close it
                    var sec = JSON.parse(JSON.stringify(this.covid_fields[i]));

                    //Unset the base section
                    delete sec.base_section;

                    //Push onto options
                    covid_fields.push(sec);
                }

                //Send it
                return covid_fields;
            },

            getTabTitle(){
                //Setup
                var title = '';
                var icon = 'bars';

                //Switch
                switch(this.curTab)
                {
                    case 'history':
                        //Set
                        title = 'History';
                        icon = 'clock';
                        break;
                }

                //Send it
                return '<i class="fa fa-'+icon+'"></i> ' + title;
            }
        },

        methods: {

            getEntry() {
                //Get the data
                this.$http
                    .get('/custom-forms/entry/view/' + this.id)
                    .then(response => {
                        //Set all the data
                        this.entry = response.data.entry;
                        this.personnel = response.data.personnel;

                        //Setup Sections
                        this.covid_fields = typeof this.entry.covid_fields == 'string' ? JSON.parse(this.entry.covid_fields) : this.entry.covid_fields;

                        //Load the sig
                        if(this.entry.signature_file_id)
                        {
                            //Load it
                            this.loadSignature(this.entry.signature_file_id);
                        }

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            loadSignature(signature_file_id){
                //Send it
                this.$http.get('files/view/'+signature_file_id, {display_type: 'fluid'})
                    .then(response => {
                        //Sent the ref
                        this.$refs.signatureFile.src = response.data;
                    })
                    .catch(err => {
                        switch(err.status)
                        {
                            case 410:
                                //Stop here?
                                //this.$refs['file-' + file.file_id][0].src = '/Images/file-not-found.png';
                                break;
                        }
                    });

                //Need to return null so it fills the source
                return null;
            },

        },
        mounted() {
            //Get the Safety Meeting
            this.getEntry();
        }
    }
</script>
